import { render, staticRenderFns } from "./menu-item-cmp.vue?vue&type=template&id=88e62dfe&scoped=true"
import script from "./menu-item-cmp.vue?vue&type=script&lang=js"
export * from "./menu-item-cmp.vue?vue&type=script&lang=js"
import style0 from "./menu-item-cmp.vue?vue&type=style&index=0&id=88e62dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e62dfe",
  null
  
)

export default component.exports